import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Popover from './Popover';
import { formatDate } from '../helpers/core';

class TaskItem extends Component {
	constructor (props) {
		super(props);

		this.state = {
			isEditMode: false,
			userComment: props.item.user_comment,
			isConfirmVisible: false
		}
	}

	changeComment = e => {
		this.setState({
			userComment: e.target.value
		});
	}

	toggleEditMode = e => {
		e.preventDefault();
		this.setState(prevState => ({
			isEditMode: !prevState.isEditMode
		}));
	}

	sendComment = e => {
		this.props.onCommentChange({user_comment: this.state.userComment, id: this.props.item.id});
		this.toggleEditMode(e);
	}

	handleDoneClick = e => {
		e.preventDefault();

		this.setState({
			isConfirmVisible: true
		});
	}

	onDoneConfirmClick = () => {
		Promise.resolve(
			this.props.isForAdmin ?
				this.props.onRemoveTask(this.props.item.id) :
				this.props.onMoveTaskToDone({finished: true, id: this.props.item.id}))
			.then(() => this.props.loadTasksFinished());
		this.hideConfirmPopover();
	}

	hideConfirmPopover = () => {
		this.setState({
			isConfirmVisible: false
		});
	}

	render () {
		const { finished, comment, user_comment, deadline, finished_time} = this.props.item;
		const { userComment, isEditMode } = this.state;
		const { isForAdmin, loading } = this.props;

		return (
			<div className="list-group-item row">
				<div className="col-xs-7 task-comment">
					<div className="col-xs-2">
						<span className={cn('label', {
							'label-success': finished,
							'label-warning': !finished
						})}>{finished ? 'Завершена' : 'В работе'}</span>
					</div>
					<div className="col-xs-10">{comment}</div>
					{user_comment && !isEditMode ?
						<div className="clearfix user-comment pull-right col-xs-8 mr-top-20">
							<blockquote><small>{user_comment}</small></blockquote>
						</div> : null
					}
					{
						!finished && !isForAdmin ?
							(!isEditMode ?
								<div className="col-xs-12">
									<a href="" title="" onClick={this.toggleEditMode}>
										{user_comment ? 'Редактировать комментарий' : 'Добавить комментарий'}
									</a>
								</div> :
								<div className="task-comment-form col-xs-12 mr-top-20">
									<textarea className="custom-textarea" value={userComment || ''} onChange={this.changeComment} disabled={loading} />
									<div className="clearfix">
										<button className="btn btn-success pull-left mr-right-20" onClick={this.sendComment} disabled={loading}>Отправить</button>
										<button className="btn btn-danger pull-left" onClick={this.toggleEditMode} disabled={loading}>Отмена</button>
									</div>
								</div>) : null
					}
				</div>
				<div className="col-xs-2">
					Сделать до:<br/>
					{formatDate(deadline)}
				</div>
				<div className="col-xs-2">
					{
						finished ?
							<span>
								Задача сделана:<br/>
								{formatDate(finished_time)}
							</span> : null
					}
				</div>
				<div className="col-xs-1">
					{!finished || isForAdmin ? <a href="" title={isForAdmin ? 'Удалить задачу' : 'Перевести в Выполнено'} onClick={this.handleDoneClick} className="close-icon text-danger">&times;</a> : null}

					{this.state.isConfirmVisible ? <Popover title={isForAdmin ? 'Удалить задачу?' : 'Завершить задачу?'}>
						<div className="clearfix">
							<button className="btn btn-success pull-left mr-right-20" onClick={this.onDoneConfirmClick}>
								{isForAdmin ? 'Да' : 'Да, она готова'}
							</button>
							<button className="btn btn-danger pull-left" onClick={this.hideConfirmPopover}>Нет</button>
						</div>
					</Popover> : null}
				</div>
			</div>
		);
	}
}

TaskItem.propTypes = {
	item: PropTypes.object,
	onCommentChange: PropTypes.func,
	onMoveTaskToDone: PropTypes.func,
	loadTasksFinished: PropTypes.func,
	onRemoveTask: PropTypes.func,
	loading: PropTypes.bool,
	isForAdmin: PropTypes.bool
};

TaskItem.defaultProps = {
	onCommentChange: () => {},
	onMoveTaskToDone: () => {},
	loadTasksFinished: () => {},
	onRemoveTask: () => {}
}

export default TaskItem;


// WEBPACK FOOTER //
// ./components/TaskItem.js